import { Injectable } from "@angular/core";
import { ShellDomainProvider } from "../utility/shell-domain.provider";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EcapEsignatureService {

    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    private messageSource = new BehaviorSubject<string>(null);
    currentMessage = this.messageSource.asObservable();

    constructor(private http: HttpClient) {
    }
    addDocument(payload): any {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/AddDocument' + "?cacheBuster=" + new Date().getTime(),
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    updateDocument(payload): any {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/UpdateDocument' + "?cacheBuster=" + new Date().getTime(),
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    addSignatory(payload): any {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/AddSignatory' + "?cacheBuster=" + new Date().getTime(),
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    removeSignatory(payload): any {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/RemoveSignatory' + "?cacheBuster=" + new Date().getTime(),
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    rolloutDocument(payload): any {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/RolloutDocument' + "?cacheBuster=" + new Date().getTime(),
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    getEsignatureData(id) {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetDocument?DocumentId=' + id + "&cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    private makeFilterString(status:string, searchKey:string, pageNo:number, pageSize:number, archived:boolean, cancelled:boolean, sortBy:string = "CreateDate", sortDir:string = "desc", IsOwned = false, IsReceived = false){
        let filterQuery = "?";
        if(status !== null && typeof status !== 'undefined'){
            filterQuery += `DocumentStatus=${status}&` ;
        }
        if(searchKey !== null && typeof searchKey !== 'undefined'){
            filterQuery += `SearchKey=${searchKey}&` ;
        }
        pageNo ? filterQuery += `PageNumber=${pageNo}&` : filterQuery += `PageNumber=0&`;
        pageSize ? filterQuery += `PageSize=${pageSize}&` : filterQuery += `PageSize=10&`;
        if(archived !== null && typeof archived !== 'undefined'){
            filterQuery += `IsArchived=${archived}&` ;
        }
        if(cancelled !== null && typeof cancelled !== 'undefined'){
            filterQuery += `Cancelled=${cancelled}&` ;
        }
        if(IsOwned){
          filterQuery += `IsOwned=${IsOwned}&` ;
        }
        if(IsReceived){
          filterQuery += `IsReceived=${IsReceived}&` ;
        }
        const SortDir = sortDir === "asc"? "1": "0";
        return filterQuery += `Sort=${SortDir}&SortBy=${sortBy}`;
        // 'Sort=0&SortBy=CreateDate'
    }

    getDocumentsToSign(status?:string, searchKey?:string, pageNo?:number, pageSize?:number, archived?:boolean,cancelled?:boolean,sortBy?:string, sortDir?:string, IsOwned?: boolean, IsReceived?: boolean) {

        let filterQuery = this.makeFilterString(status,searchKey,pageNo,pageSize,archived,cancelled,sortBy,sortDir, IsOwned, IsReceived);
        return this.http.get(`${ShellDomainProvider['api'].SeliSignService}SeliSign/Queries/GetDocumentsToSign${filterQuery}` + "&cacheBuster=" + new Date().getTime(),
                { headers: this.header, withCredentials: true, observe: 'response' });

        // if (status && searchKey) {
        //     return this.http.get(`${ShellDomainProvider['api'].SeliSignService}SeliSign/Queries/GetDocumentsToSign?DocumentStatus=${status}&SearchKey=${searchKey}&PageNumber=${pageNo}&PageSize=${pageSize}&Sort=0&SortBy=CreateDate` + "&cacheBuster=" + new Date().getTime(),
        //         { headers: this.header, withCredentials: true, observe: 'response' });
        // } else {
        //     if (status) {
        //         return this.http.get(`${ShellDomainProvider['api'].SeliSignService}SeliSign/Queries/GetDocumentsToSign?DocumentStatus=${status}&PageNumber=${pageNo}&PageSize=${pageSize}&Sort=0&SortBy=CreateDate` + "&cacheBuster=" + new Date().getTime(),
        //             { headers: this.header, withCredentials: true, observe: 'response' });
        //     } else {
        //         if (searchKey) {
        //             return this.http.get(`${ShellDomainProvider['api'].SeliSignService}SeliSign/Queries/GetDocumentsToSign?SearchKey=${searchKey}&PageNumber=${pageNo}&PageSize=${pageSize}&Sort=0&SortBy=CreateDate` + "&cacheBuster=" + new Date().getTime(),
        //                 { headers: this.header, withCredentials: true, observe: 'response' });
        //         } else {
        //             return this.http.get(`${ShellDomainProvider['api'].SeliSignService}SeliSign/Queries/GetDocumentsToSign?PageNumber=${pageNo}&PageSize=${pageSize}&Sort=0&SortBy=CreateDate` + "&cacheBuster=" + new Date().getTime(),
        //                 { headers: this.header, withCredentials: true, observe: 'response' });
        //         }

        //     }
        // }
    }
    getSignatories(documentId) {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetSignatories?DocumentId=' + documentId + "&cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    getSignatoriesForDocuments(payload) {
      return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetSignatoriesForDocuments' + "?cacheBuster=" + new Date().getTime(), payload,
          { headers: this.header, withCredentials: true, observe: 'response' });
    }

    signDocument(payload) {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/SignDocument' + "?cacheBuster=" + new Date().getTime(), payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    getSignatoryLog(documentId) {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetSignatures?DocumentId=' + documentId + "&cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    resendEsignaturLink(payload) {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/ResendInvitation' + "?cacheBuster=" + new Date().getTime(), payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    signTheDocumentOnBehalf(payload) {
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/SignDocumentOnBehalf' + "?cacheBuster=" + new Date().getTime(), payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    getEsignatureConfiguration() {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetEsignatureSettings' + "?cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    triggerEvent(message: string) {
        this.messageSource.next(message)
    }
    signatureInProgress(documentId: string, signatoryId: string) {
        return this.http.get(`${ShellDomainProvider['api'].SeliSignService}SeliSign/Queries/SignatureInProgress?DocumentId=${documentId}&SignatoryId=${signatoryId}` + "&cacheBuster=" + new Date().getTime(), { headers: this.header, withCredentials: true, observe: 'response' });
    }
    GetSignedFileMaps(documentId: string) {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetSignedFileMaps?DocumentId=' + documentId + "&cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    GetEvidenceLog(documentId: string) {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetSignatureLog?DocumentId=' + documentId + "&cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    GetSignDocumentsFiles(documentId: string) {
        return this.http.get(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Queries/GetSignedDocuments?DocumentId=' + documentId + "&cacheBuster=" + new Date().getTime(),
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    ArchiveDocumenCommand(DocumentIds:string[]){
        let paylaod = {DocumentIds}
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/ArchiveDocument', paylaod,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    CancelWorkflowCommand(DocumentIds:string[]){
        let paylaod = {DocumentIds}
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/cancelworkflows', paylaod,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    UnArchiveDocumentCommand(DocumentIds:string[]){
        let paylaod = {DocumentIds}
        return this.http.post(ShellDomainProvider['api'].SeliSignService + 'SeliSign/Commands/UnArchiveDocument', paylaod,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
}
